import { render, staticRenderFns } from "./DemoForm.vue?vue&type=template&id=4293b4d4&"
import script from "./DemoForm.vue?vue&type=script&lang=ts&"
export * from "./DemoForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports